import { ReactComponent as ShareSVG } from "./share.svg";
import { SvgIcon } from '@mui/material';

export default function IconShare(props) {
  return <SvgIcon {...props} component={ShareSVG} viewBox="0 0 31 30" />;
}